/**
 * 判断字符串是否为团队对外 ID 格式（7 位字母+数字，不含易混淆字符）。
 * @param value 用户输入
 */
export function isTeamPublicIdFormat(value: string): boolean {
  return /^[A-Z0-9]{7}$/.test(String(value ?? '').trim().toUpperCase());
}

/**
 * 规范化团队对外 ID（大写、去空白）。
 * @param value 用户输入
 */
export function normalizeTeamPublicId(value: string): string {
  return String(value ?? '').trim().toUpperCase();
}
